<script setup lang="ts">
const appStore = useAppStore();

const isWaiting = computed(() => appStore.loading);
const isWaitingDebounced = useDebounce(isWaiting, 300);
</script>
<template>
  <div
    v-if="isWaitingDebounced"
    v-show-popover
    class="w-screen h-screen fixed inset-0 z-[60] bg-ngray-6/25 backdrop-blur-sm flex justify-center items-center"
  >
    <img src="/svg/spinner.svg" class="w-32 h-10 animate-spin" :alt="$t('alt.spinner')" />
  </div>
</template>
